import { Flex } from 'antd'

import { Empty } from 'shared/ui/empty'
import { EmptyStateType } from 'shared/ui/empty/types'

import styles from './Offline.module.scss'

export function Offline() {
  return (
    <Flex align="center" justify="center" className={styles.wrapper}>
      <Empty
        showImage={false}
        variant={EmptyStateType.NO_CONNECTION}
        hasButton={false}
      />
    </Flex>
  )
}
